import dayjs from 'dayjs';

export function formatMoney(value) {
  if (value === null || value === undefined || value === '') return '-';
  const number = Number(value);
  if (Number.isNaN(number)) return '-';
  return `¥${number.toLocaleString('zh-CN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

export function formatDateTime(value) {
  if (!value) return '-';
  const date = dayjs(value);
  return date.isValid() ? date.format('YYYY-MM-DD HH:mm:ss') : String(value);
}

export function formatPercent(value) {
  if (value === null || value === undefined || value === '') return '-';
  return `${Number(value).toFixed(2)}%`;
}

export function monthText(value) {
  return value ? dayjs(value).format('YYYY-MM') : undefined;
}

export function dayStart(value) {
  return value ? dayjs(value).startOf('day').format('YYYY-MM-DD HH:mm:ss') : undefined;
}

export function dayEnd(value) {
  return value ? dayjs(value).endOf('day').format('YYYY-MM-DD HH:mm:ss') : undefined;
}
